import React, { useContext } from 'react';
import { Container } from 'components/common';
import {
  name,
  linkedinUrl,
  githubUrl,
  gmailUrl,
  discordUrl,
  twitterUrl,
} from "data/config";
import { ThemeContext } from "providers/ThemeProvider";
import crio from "assets/illustrations/crio.png";
import gamil from "assets/illustrations/gmail.png";
import linkedinLogo from "assets/illustrations/linkedin.png";
import githubLogo from "assets/illustrations/github.png";
import discordLogo from "assets/illustrations/discord.png";
import twitterLogo from "assets/illustrations/twitter.png";

import { Wrapper, Flex, Details } from "./styles";

export const Footer = () => {
  const { theme } = useContext(ThemeContext);
  return (
    <Wrapper>
      <Flex>
        <Details
          className={` ${theme === "light" ? "footer-light" : "footer-dark"}`}
        >
          <Container>
            <div className='root-container'>
              <div>
                <h2>{name}</h2>
                <span>
                  © All rights are reserved | {new Date().getFullYear()}{" "}
                </span>
              </div>{" "}
              <div>
                {" "}
                <a href={gmailUrl} target='_blank' rel='noreferrer'>
                  <img width='45' src={gamil} alt='gamil' />
                </a>
                <a href={linkedinUrl} target='_blank' rel='noreferrer'>
                  <img width='45' src={linkedinLogo} alt='Linkedin' />
                </a>
                <a href={githubUrl} target='_blank' rel='noreferrer'>
                  <img width='45' src={githubLogo} alt='GitHub' />
                </a>
                <a href={twitterUrl} target='_blank' rel='noreferrer'>
                  <img width='45' src={twitterLogo} alt='Twitter' />
                </a>
                <a href={discordUrl} target='_blank' rel='noreferrer'>
                  <img width='45' src={discordLogo} alt='Discord' />
                </a>
                <a
                  href='https://www.buymeacoffee.com/majjikishore'
                  target='_blank'
                >
                  <img
                    src='https://cdn.buymeacoffee.com/buttons/default-orange.png'
                    alt='Buy Me A Coffee'
                    height='41'
                    width='174'
                  />
                </a>
              </div>
            </div>
          </Container>
        </Details>{" "}
      </Flex>
    </Wrapper>
  );
};
